import React from "react";
import * as Icon from "react-bootstrap-icons";
import { useState, useRef , useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateEngageQuestions, addEngageQuestions, addWidgetQuestions, fetchLeadListing, fetchEditData } from "../../redux/actions/chatAiActions";
import Loading from "../assetLibComponents/Loading";
import { ArrowLeft } from "react-bootstrap-icons/dist";
import ChatbotViewer from "./ChatbotViewer";
import { Fragment } from 'react'
import { Menu, Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import MultiSelect from "./MultiSelect";
import { List } from "react-movable";
import Toast from "../assetLibComponents/shared/Toast";
import SelectMenu from "../chatAiComponents/SelectMenu";
import TextInput from "./TextInput";
import "../chatAiComponents/ChatAii.css"
import { IoClose } from "react-icons/io5";



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const people = [
  { id: 1, name: 'Text Widget' },
  { id: 2, name: 'Tab Widget' }
]

const ChatEngageProfile = (props) => {
  const dispatch = useDispatch();
  const listQuestion = useRef();
  const dropdownRef = useRef();
  const questionEl = useRef();
  const [currentActivePage, setCurrentActivePage] = useState("listing");
  const [currentSettingPage, setCurrentSettingPage] = useState("listing");
  const [questionActive, setQuestionActive] = useState(false);
  const [currentAction, setCurrentAction] = useState(false);
  const [failureFlag, setFailureFlag] = useState(false);
  const [customizeDuration, setCustomizeDuration] = useState(false);
  const [customizePrompt, setCustomizePrompt] = useState(false);
  const [durationValue, setDurationValue] = useState("");
  const [dropControl, setDropControl] = useState("");
  const [promptValue, setPromptValue] = useState("");
  const [acknowledgementValue, setAcknowledgementValue] = useState("");
  const [responseTypeDrop, setResponseTypeDrop] = useState([]);
  const [actualResponseType, setActualResponseType] = useState([]);
  const isLoading = useSelector((state) => state.chatAi.loading);
  const api_call_hider = useSelector((state) => state.chatAi.apiCallHider);
  const edit_engage = useSelector((state) => state.chatAi.edit_engage);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [calendarTrigger, setCalendarTrigger] = useState([]);

  const handleCalendarTrigger = (event) => {
    setInputValue(event.target.value);
    };

  // const handleKeyDown = (event) => {
  //   if ((event.key === ' ' || event.key === 'Spacebar' || event.keyCode === 32) && inputValue.trim() !== '') {
  //     // If spacebar is pressed and input value is not empty
  //     setCalendarTrigger([...calendarTrigger, inputValue.trim()]); // Add input value to array
  //     setInputValue(''); // Clear input field
  //   }
  // };
  
  const lead_listing_data = useSelector((state) => state.chatAi.lead_listing_data?.details?.details);
  const lead_trigger_data = useSelector((state) => state.chatAi.lead_listing_data?.details);
  const lead_meeting_data = useSelector((state) => state.chatAi.lead_listing_data?.meeting_data);
  const [leadListing, setLeadListing] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPage, setSelectedPage] = useState("Widgets");
  const [meetingQuestion, setMeetingQuestion] = useState("");
  const engage_drop_down = useSelector((state) => state.chatAi.engage_drop_down);
  
  const duration_list = [
    { id: 1, value: "30" },
    { id: 2, value: "60" },
    { id: 3, value: "90" },
  ]
  
  const prompt_select_list = [
    { id: 1, value: "3" },
    { id: 2, value: "4" },
    { id: 3, value: "5" },
  ]
  
  // Function to handle adding a new todo
  const addTodo = async (e, item, parent_item) => {
    e.preventDefault();
    let innerQuestionCount = 0
    innerQuestionCount = parent_item?.questions?.length;
    if (parent_item.widget_type === "multi") {
      let addPerfectTodo = [];
      const newTodo = {
        self_id: innerQuestionCount+1,
        priority: innerQuestionCount+1,
        question: item.question || "",
        response_type: item,
        deleted: false,
        options: []
      };
      
      await leadListing.map((lead,l_index) => {
        if (parent_item.group_id === lead.group_id) {
          addPerfectTodo = [...lead.questions,newTodo];
        }
        return lead;
      })      
      
      addPerfectTodo.sort((a, b) => a.group_id - b.group_id);
      
      leadListing.map((lead) => {
        if (parent_item.group_id === lead.group_id) {
          lead.questions = addPerfectTodo
        }
        return lead;
      })
      let updatedType = [...actualResponseType]
      
      let data = updatedType.filter(obj => obj.id !== item.id);
      setResponseTypeDrop(data);
    }
    else if (parent_item.widget_type === "single") {
      let addPerfectTodo = [];
      const newTodo = {
        self_id: innerQuestionCount+1,
        priority: innerQuestionCount+1,
        question: item.question || "",
        response_type: item,
        deleted: false,
        options: []
      };
      await leadListing.map((lead,l_index) => {
        if (parent_item.group_id === lead.group_id) {
          addPerfectTodo = [...lead.questions,newTodo];
        }
        return lead;
      })      
      
      addPerfectTodo.sort((a, b) => a.group_id - b.group_id);
      
      leadListing.map((lead) => {
        if (parent_item.group_id === lead.group_id) {
          lead.questions = addPerfectTodo
        }
        return lead;
      })
      let updatedType = [...actualResponseType]
      
      let data = updatedType.filter(obj => obj.id !== item.id);
      setResponseTypeDrop(data);
    }
    else {
      const newTodo = {
        self_id: innerQuestionCount+1,
        priority: innerQuestionCount+1,
        question: item.question || "",
        response_type: item,
        deleted: false,
        options: []
      };
      const addPerfectTodo = [newTodo];
      addPerfectTodo.sort((a, b) => a.self_id - b.self_id);
      
      leadListing.map((lead,l_index) => {
        if (parent_item.group_id === lead.group_id) {
          lead.questions = addPerfectTodo
        }
        return lead;
      })
      let updatedType = [...actualResponseType]
      
      let data = updatedType.filter(obj => obj.id !== item.id);
      setResponseTypeDrop(data);
    }
  };
  
  
  const handleFailure = () => {
    dispatch(fetchEditData(props.authToken, api_call_hider));
  }
  
  const chatOpenHandle = (value) => {
    setOpen(value);
  }

  useEffect(()=>{
    if(lead_meeting_data){
      setMeetingQuestion(lead_meeting_data?.question !== "" ? lead_meeting_data?.question : "")        
      setInputValue(lead_meeting_data?.meeting_triggers !== "" ? lead_meeting_data?.meeting_triggers?.join(",") : [])        
    }
  },[lead_meeting_data])
  
  useEffect(() => {
    if (edit_engage && edit_engage?.details?.length > 0) {
      setCurrentAction(true);
      setLeadListing(edit_engage?.details);
      if (failureFlag === false) {
        setQuestionActive(false);   
        setDurationValue(edit_engage?.time_duration !== null ? edit_engage?.time_duration : "");
        setPromptValue(edit_engage?.chat_length !== null ? edit_engage?.chat_length : "");  
        setAcknowledgementValue(edit_engage?.acknowledgment !== "" ? edit_engage?.acknowledgment : "")        
      }
      const temp = [...engage_drop_down];
      const newTypeValue = [...edit_engage?.details]
      const idsToRemove = [];
      let data;
      for (let i = 0; i < newTypeValue?.length; i++) {
        let valueArray = newTypeValue[i];
        if ("id" in valueArray) {
          delete valueArray.id;
        }
        for (let j = 0; j < valueArray?.questions?.length; j++){
          let questionArray = valueArray?.questions[j];
          if ("id" in questionArray) {
            delete questionArray.id;
          }
          if (questionArray?.response_type && questionArray?.response_type !== null && Object.keys(questionArray?.response_type) && Object.keys(questionArray?.response_type)?.length > 0) {
            idsToRemove.push(questionArray.response_type.value);
          }
        }
      }

      data = temp.filter(obj => !idsToRemove.includes(obj.value));
      setResponseTypeDrop(data);

      if (edit_engage?.time_duration !== "30" && edit_engage?.time_duration !== "60" && edit_engage?.time_duration !== "90" && edit_engage?.time_duration !== null) {
        setCustomizeDuration(false);
      }
      if (edit_engage?.chat_length !== "3" && edit_engage?.chat_length !== "4" && edit_engage?.chat_length !== "5" && edit_engage?.chat_length !== null) {
        setCustomizePrompt(false);
      }
    } else {
      setLeadListing([]);
      if (leadListing?.length === 0) {
        setQuestionActive(true);
        setCurrentAction(false);
      }
    }
  }, [edit_engage])
  
  useEffect(() => {
    setResponseTypeDrop(engage_drop_down);
  }, [engage_drop_down])
  
  useEffect(() => {
    if (questionActive === false) {
      dispatch(fetchEditData(props.authToken, api_call_hider));
    }
  }, [questionActive])
  
  
  const backToList = () => {
    setQuestionActive(false);
    setFailureFlag(false);
  }
  
  useEffect(() => {
    return () => {
      backToList();
    }
  }, [])
  
  const submitTrigger = async () => {
    if (promptValue === "" && durationValue === "" ) {
      Toast(`Please Enter The Duration or Prompt Value`, 'E');
    } else if (acknowledgementValue ==="") {
      Toast(`Please Enter Acknowledgement`, 'E');
    } else {
      let payload;
        payload = {
          trigger_id: "0",
          chat_length: promptValue ? promptValue : null,
          time_duration: null,
          acknowledgement: acknowledgementValue,
          triggers: inputValue.split(',')
      }
      if (((edit_engage?.time_duration === null || edit_engage?.time_duration === "") && (edit_engage?.chat_length === null || edit_engage?.chat_length === "") && (edit_engage?.acknowledgment === null || edit_engage?.acknowledgment === ""))) {
        await dispatch(addEngageQuestions(props.authToken, onSuccess, payload, "trigger_data"));
      } else {
        await dispatch(updateEngageQuestions(props.authToken, onSuccess, payload, "trigger_data"));
      }
    }
  }
  const submitMeetingQuestion = async () => {
    if (meetingQuestion === "") {
      Toast(`Please Enter The Meeting Question`, 'E');
    }  else {
      let payload;
        payload = {
          trigger_id: "0",
          chat_length: promptValue ? promptValue : null,
          time_duration: null,
          acknowledgement: acknowledgementValue,
          question:meetingQuestion,
      }
      
        await dispatch(updateEngageQuestions(props.authToken, onSuccess, payload, "meeting_data"));
    }
  }
  
  const submitQuestions = async () => {
    let questionArrayDataNew = [...leadListing];
    let newArr = await questionArrayDataNew.filter((item) => {
      let i_q_data = item.questions.filter((i_item) => {
        // i_item.response_type.options = [];
        return i_item.deleted !== true;
      })
      item.questions = i_q_data;
      return item.deleted !== true;
    })
      if(newArr?.length <= 0) {
        Toast("Please Add The Group", 'E');
      }
      else {
        let byPassCheck;
        byPassCheck = false;
        for (var i = 0; i < newArr?.length; i++) {
          let quest_array = newArr[i];
          if (quest_array?.questions?.length === 0) {
            Toast(`Please add questions in Profiling Tab ${i + 1} `, 'E');
            break;
          }
          for (var j = 0; j < quest_array.questions?.length; j++){
            let i_quest_array = quest_array.questions[j];
            if (i_quest_array.question === "" || i_quest_array.question === null) {
              Toast('Question field should not be empty', 'E');
              byPassCheck = true;
              break;
            } else if (quest_array.widget_type !== "text" && i_quest_array.options.length === 0) {
              Toast('Please select some answers to highlight.', 'E');
              byPassCheck = true;
              break;
            } else {
              if (i === newArr?.length - 1 && j === quest_array.questions?.length - 1 && byPassCheck === false) {
                await newArr.map((payload, p_index) => {
                  payload.group_id = p_index + 1;
                  payload.priority = p_index + 1;
                  
                  payload.questions.map((inner_payload, i_p_index) => {
                    inner_payload.self_id = i_p_index + 1;
                    inner_payload.priority = i_p_index + 1;
                    return inner_payload;
                  })
                  return payload;
                });
                await dispatch(addWidgetQuestions(props.authToken, onSuccess, newArr, "counter_data"));
              }
            }
          }
        }
      }
  }
  
  const onSuccess = async (value, action) => {
    switch (value) {
      case "add_lead":
        if (action === "trigger_data") {
          await dispatch(fetchLeadListing(props.authToken, api_call_hider));
          await dispatch(fetchEditData(props.authToken, api_call_hider));
          setCurrentActivePage("listing");
          backToList();
        } else {           
          await dispatch(fetchLeadListing(props.authToken, api_call_hider));
          await dispatch(fetchEditData(props.authToken, api_call_hider));
          setCurrentActivePage("listing");
          backToList();
        };
        break;
      case "update_lead":
        if (action === "trigger_data" || action === "meeting_data") {
          await dispatch(fetchLeadListing(props.authToken, api_call_hider));
          await dispatch(fetchEditData(props.authToken, api_call_hider));
          setCurrentActivePage("listing");
          setCurrentSettingPage("listing");
          backToList();
        } else {           
          await dispatch(fetchLeadListing(props.authToken, api_call_hider));
          await dispatch(fetchEditData(props.authToken, api_call_hider));
          setCurrentActivePage("listing");
          setCurrentSettingPage("listing");
          backToList();
        };
        break;
      case "fail":
        setFailureFlag(true);
        handleFailure();
        break;
      default:
        break;
    }
  }
  
  const handleInputChange = async (event, type, index, inner_index) => {
    const newInputValues = [...leadListing];
    const newArr = await newInputValues.map((obj) => {
      if (obj.group_id === index) {
        obj.questions.map((i_obj) => {
          if (i_obj.self_id === inner_index) {
            i_obj.question = event.target.value
          }
          return i_obj;
        })
      }
      return obj;
    });
    setLeadListing(newArr);
  };
  
  const handleMultipleInputChange = async (selected, g_id, s_id) => {
    if (selected.length > 3) {
      Toast("Select up to three options only", "E");
      return;
    }
    
    const newInputValues = [...leadListing];
    
    const selectedIds = selected.map((select_inside, s_index) => {
      return select_inside.id;
    });
    
    const newArr = [];

    for (const obj of newInputValues) {
      if (obj.group_id === g_id) {
        for (const i_obj of obj.questions) {
          if (i_obj.self_id === s_id) {
            const remainingArray = i_obj.options.filter(obj_c => !selectedIds.includes(obj_c.id));
            i_obj.options = selected;
            let choices = i_obj?.response_type?.options;
            let sortedArray1 = [...choices, ...remainingArray];
            // const sortedArray1 = mergedArray.slice().sort((a, b) => a.id - b.id);
            // i_obj.response_type.options = sortedArray1;
            
            const newArray = [];
            sortedArray1.forEach((obj) => {
              const existingObject = newArray.find((mergedObj) => mergedObj.id === obj.id);

              if (existingObject) {
                // Merge the properties of the current object into the existing object
                Object.assign(existingObject, obj);
              } else {
                // If no existing object is found, add the current object to the merged array
                newArray.push({ ...obj });
              }
            });

            i_obj.response_type.options = newArray;
          }
        }
      }
      newArr.push(obj);
    }
    setLeadListing(newArr);
  };
  
  const removeQuestion = async(id, g_id, type) => {
    const updatedArray = [...leadListing]
    const newArr = await updatedArray.map((obj, ind) => {
      if (g_id === obj.group_id) {
        obj.questions = obj.questions.filter(i_obj => {
          return i_obj.self_id !== id;
        });
      }
      return obj;
    });
    setLeadListing(newArr);
    
    const list = [...responseTypeDrop];
    
    if (Object.keys(type).length > 0) {
      list.push(type);
      setResponseTypeDrop(list);
    }
  }
  
  const removeGroup = async (g_id, data) => {
    const updatedArray = [...leadListing];
    const newArr = await updatedArray.filter(obj => obj.group_id !== g_id);
    setLeadListing(newArr);
    
    const list = [...responseTypeDrop];
    
    data.questions.map((ig_obj, ig_ind) => {
      if (Object.keys(ig_obj?.response_type)?.length > 0) {
        list.push(ig_obj?.response_type);
      }
    })
    
    setResponseTypeDrop(list);
  }
  
  const checkVisiblity = (check, data) => {
    if (data.length > 0) {
      let dataInside = data.filter((i_obj) => i_obj.deleted === true)
      if (check === "data") {
        if (dataInside.length === data.length) {
          return false;
        } else {
          return true;
        }
      } else {
        if (dataInside.length === data.length) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  
  const routeFlow = async () => {
    if (currentSettingPage === "edit_t_a" || currentSettingPage === "edit_a") {
      await submitTrigger();
    } else if(currentActivePage === "edit_m_q"){
      await submitMeetingQuestion();
    } else {
      await submitQuestions();
    }
    
  }
  
  const addTextTodo = () => {
    // e.preventDefault();
    const newTodo = {
      deleted: false,
      group_id: leadListing.length + 1,
      questions: [],
      priority: leadListing.length + 1,
      widget_type: "text"
    };
    const addPerfectTodo = [...leadListing, newTodo];
    setLeadListing(addPerfectTodo);
    setTimeout(() => {
      scrollDown();  
    }, 200);
  }
  
  const scrollDown = () => {
    // Assuming questionEl.current is not null
    if (questionEl.current) {
      questionEl.current.scrollTop = questionEl.current.scrollHeight+400;
    }
  };
  
  const addSingleTodo = () => {
    // e.preventDefault();
    const newTodo = {
      deleted: false,
      group_id: leadListing.length + 1,
      questions: [],
      priority: leadListing.length + 1,
      widget_type: "single"
    };
    const addPerfectTodo = [...leadListing, newTodo];
    setLeadListing(addPerfectTodo);
    setTimeout(() => {
      scrollDown();  
    }, 200);
  }
  
  // const addMultipleTodo = (e) => {
  //   e.preventDefault();
  //   const newTodo = {
  //     deleted: false,
  //     group_id: leadListing.length,
  //     questions: [],
  //     widget_type: "multi"
  //   };
  //   const addPerfectTodo = [...leadListing, newTodo];
  //   setLeadListing(addPerfectTodo);
  // }
  
  const disableHandle = (data, type) => {
    if (data.questions.length > 0) {
      let count = 0;
      data.questions.map((item) => {
        if (item.deleted === false) {
          count++;
        }
      })
      if (count >= 3 && type === "multi") {
        return true;
      } else if (count >= 1 && type === "text") {
        return true;
      } else if (count >= 3 && type === "single") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } 
    
  const handleGroupChange = ({ oldIndex, newIndex }, data) => {
    if (newIndex !== 0 && newIndex !== 1) {
      const removedObject = data.splice(oldIndex, 1);
      data.splice(newIndex, 0, removedObject[0]);
      data.map((data_obj, d_ind) => {
        data_obj.group_id = d_ind;
        data_obj.priority = d_ind + 1;
        return data_obj;
      })
    } else {
      Toast("Priority 1 and 2 are fixed for email and company website.", "E")
    }
    
  }; 
  
  const handleQuestionsChange = ({ oldIndex, newIndex },data) => {
    const removedObject = data.splice(oldIndex, 1);
    data.splice(newIndex, 0, removedObject[0]);
    data.map((data_obj, d_ind) => {
      data_obj.self_id = d_ind + 1;
      data_obj.priority = d_ind + 1;
      return data_obj;
    })
  };
  /////////////////////////////////////////////////////////////////////////////
  
  useEffect(() => {
    if (responseTypeDrop?.length > 0) {
      responseTypeDrop.sort((a, b) => a.id - b.id);
      setActualResponseType(responseTypeDrop);
    } else {
      setActualResponseType(responseTypeDrop);
    }
  }, [responseTypeDrop]);
  
  useEffect(() => {
    dispatch(fetchEditData(props.authToken, api_call_hider));
    dispatch(fetchLeadListing(props.authToken, api_call_hider));
  }, []);
  
  useEffect(() => {
    if (listQuestion) {
        listQuestion?.current?.addEventListener('DOMNodeInserted', event => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight});
      });
    }
    if (dropdownRef) {
        dropdownRef?.current?.addEventListener('DOMNodeInserted', event => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight});
      });
    }
  }, [leadListing, dropControl])
  
  const questionTitleData = (data) => {
    let str = data?.map((ques, ind) => {
      if (ind < data?.length-1) {
        return ques.label + ", "                           
      } else {
        return ques.label;
      }  
    })
    return str;
  }

  const questionData = (data) => {
    let str = data?.map((ques, ind) => {
      if (ind < data?.length-1) {
        return ques.label + "";                            
      } else {
        if (data?.length < 2) {
          return ques.label;
        } else {
          return "...";
        }
      }  
    })
    return str;
  }
  
  const questionStringData = (data) => {
    let str = data?.map((ques, ind) => {
      if (ind < data?.length-1) {
        return ques?.question + ", ";                            
      } else {
        return ques?.question;
      }  
    })
    return str;
  }
  
  const handleAddWidget = (e) => {
    setCurrentActivePage("add_c_q")
    if (e?.id === 1) {
      addTextTodo();
    } else {
      addSingleTodo();
    }
  }
  
  return (
    <>
      {(isLoading) && <Loading />}
      <div className="chat-ai-asset chatUrl">
        {/* Heading with Button */}
        <div className="flex justify-between mb-[5px] border-b border-gray-200 pb-4">
          {/* <div className="text-lg leading-7 font-[500] my-auto">Profiling</div> */}
          <div className="flex my-auto">
            <div onClick={()=>{setSelectedPage("Widgets");setCurrentActivePage("listing");setCurrentSettingPage("listing")}} className={` ${selectedPage === "Widgets" ?  "border-b-2 border-[var(--brand-primary)] py-2   text-black":"hover:border-b-2 hover:border-[var(--brand-primary)] border-b-0 b py-2 text-gray-500 hover:text-black"} font-semibold   cursor-pointer mr-4`}>Widgets</div>
            <div onClick={()=>{setSelectedPage("Settings");setCurrentSettingPage("listing");setCurrentActivePage("listing")}} className={` ${selectedPage === "Settings" ? "border-b-2 border-[var(--brand-primary)] py-2  text-black":"hover:border-b-2 hover:border-[var(--brand-primary)] border-b-0 b py-2 text-gray-500 hover:text-black"} font-semibold  cursor-pointer mr-3 `}>Settings</div>

          </div>
          <div className="flex">
            {(currentActivePage === "listing" && currentSettingPage === "listing" && selectedPage === "Widgets") && <div className="mr-4 my-auto">
              <SelectMenu people={ people } handleAddWidget={handleAddWidget} />
            </div>}
            {(currentActivePage !== "listing" || currentSettingPage !== "listing") && <div className="hover:bg-[#D1D5DB] hover:border-[rgba(83,85,86,0.1)] border border-[#D1D5DB] flex items-center gap-1.5 bg-transparent not-italic font-bold text-[14px] leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-3 mr-3" onClick={()=>{routeFlow()}}>
              <span>Save Changes</span>
            </div>}
            <button
              onClick={()=>{setOpen(true)}}
              type="button"
              className="inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
            >
            <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" />
              Test ChatAI
            </button>    
          </div>            
        </div>
        {selectedPage === "Widgets" ? <>
        {currentActivePage !== "listing" && <span onClick={() => { setCurrentActivePage("listing"); dispatch(fetchEditData(props.authToken, api_call_hider)); }} className="text-[#6B7280] text-sm not-italic font-medium leading-5 cursor-pointer flex items-center mb-2"><Icon.ChevronLeft className="text-[#6B7280] font-medium text-[13px] mr-1" aria-hidden="true" />Back</span>}
        {(false && currentActivePage === "edit_c_q") && <div className={"my-4"}>
          <div className="relative flex justify-center w-full rounded-lg border-2 border-dashed border-gray-400 p-4 text-center hover:border-gray-600 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] focus:ring-offset-2">
            <div className="w-1/2 block text-gray-700 text-sm not-italic font-semibold leading-5"><span className="cursor-pointer" onClick={addTextTodo}>+ Text Widget</span></div>
            <div className="w-1/2 block text-gray-700 text-sm not-italic font-semibold leading-5"><span className="cursor-pointer" onClick={(e) => {
              addSingleTodo(e)
            }}>+ Tab Widget</span></div>
            {/* <div className="w-1/3 block text-gray-700 text-sm not-italic font-semibold leading-5"><span className="cursor-pointer" onClick={(e) => {
              addMultipleTodo(e)
            }}>+ Tab Widget (Multiple Select)</span></div> */}
          </div>
        </div>}
        {currentActivePage === "listing" && <>
          <div className="bg-white mt-8 mb-4 drop-shadow-md">
            <h3 className="border-b flex justify-between items-center border-gray-200 text-[15px] px-4 py-3 sm:px-6 font-semibold leading-6 text-gray-900">Profiling Tabs
              {lead_listing_data?.length > 0 ? <span onClick={() => { setCurrentActivePage("edit_c_q") }} className="flex items-center justify-center border border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                <Icon.Pencil className="cursor-pointer text-gray-600 text-[16px]" />
              </span> :
              <span onClick={() => { setCurrentActivePage("edit_c_q") }} className="flex items-center justify-center border border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                <Icon.Plus className="cursor-pointer text-gray-600 text-[16px]" />Add
              </span>}
            </h3>
            {lead_listing_data?.length > 0 && <ul role="list" className="listing xl:max-h-[38vh] max-h-[35vh] max-sm:max-h-[50vh] max-lg:max-h-[30vh] overflow-y-auto px-4 py-0 sm:px-6 divide-y divide-gray-100">
              {lead_listing_data?.length > 0 && lead_listing_data.map((item, i_index) => (
                <li key={item.id} className="flex py-2">
                  <div className="w-[20%] max-sm:w-[40%] flex">
                    <p className="text-sm font-semibold leading-6 text-gray-900">Tab {i_index + 1} { i_index < 2 ? <span className="text-[red]">*</span>:"" }</p>
                    <span className="capitalize inline-flex ml-5 items-center rounded-md bg-gray-50 px-1.5 py-0.5 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                      {item.widget_type}
                    </span>
                  </div>
                  <div className="w-[40%] max-sm:hidden flex justify-start">
                    <span className="whitespace-nowrap block overflow-hidden text-ellipsis" title={questionStringData(item?.questions)}>{questionStringData(item?.questions)}</span>
                  </div>
                  <div className="w-[40%] max-sm:w-[60%] flex justify-end">
                      <div className="mt-1">
                        <p title={questionTitleData(item?.questions)} className="max-sm:hidden text-[14px] leading-5 text-[#000000]">
                          {questionTitleData(item?.questions)}
                        </p>
                        <p title={questionTitleData(item?.questions)} className="hidden max-sm:inline text-[14px] leading-5 text-[#000000]">
                            {questionTitleData(item?.questions)}
                        </p>
                      </div>
                  </div>
                </li>
              ))}
            </ul>}
            <h3 className="border-b flex max-sm:px-4 justify-between items-center border-gray-200 text-[12px] px-1 py-1 sm:px-2 font-medium leading-6 text-gray-400">
              * Mandatory fields help in identifying visitor from CRM data. If data already exists based on cookie captured earlier, these questions are skipped
            </h3>
            {(lead_listing_data?.length === 0) &&
              <div className="bg-white rounded-md px-6 py-3 mt-0 max-h-[58vh] overflow-y-scroll listing">
                <div className="flex justify-center items-center px-4 py-5 sm:px-6">
                <div className="text-center">
                  <h3 className="text-[14px] mb-2 font-semibold leading-6 text-gray-900">No Fields Added</h3>
                  <p className="text-[14px] font-normal">Get Started by Adding a Field</p>
                </div>
              </div>
              </div>
            }
          </div>
          {/* Calendar widget block */}
          <div className="bg-white drop-shadow-md">
            <h3 className="border-b flex justify-between items-center border-gray-200 text-[15px] px-4 py-3 sm:px-6 font-semibold leading-6 text-gray-900">Calendar Widget
              {<span onClick={() => { setCurrentActivePage("edit_m_q") }} className="flex items-center justify-center border border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                  <Icon.Pencil className="cursor-pointer text-gray-600 text-[16px]" />
                </span>
                }
            </h3>
            <div className="border-b border-gray-200 px-4 sm:px-6">
              <div className="flex max-sm:block py-2">
                <div className="w-[40%] max-sm:w-full flex">
                  <p className="text-sm font-semibold leading-6 text-gray-900">Leading Question</p>
                </div>
                <div className="w-[60%] max-sm:w-full flex max-sm:justify-start justify-end">
                    <div className="mt-1">
                      <p className="max-sm:hidden text-[14px] font-normal leading-5 text-[#000000]">
                        {lead_meeting_data?.question}
                      </p>
                      <p className="hidden max-sm:inline text-[14px] font-normal leading-5 text-[#000000] break-all">
                        {lead_meeting_data?.question} 
                      </p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </>}
        
        {currentActivePage === "add_c_q" &&
          <>
            <div ref={questionEl} className="h-[72vh] overflow-y-auto listing pr-2">
            { leadListing?.length > 0 && leadListing.map((value, index) => {
                return (
                  <div>
                      {(value.widget_type === "text" && value.deleted !== true && index === leadListing?.length-1 ) && <div className="bg-white drop-shadow-md mb-3">
                        <div data-movable-handle className="flex max-sm:block relative justify-between items-center border-b border-gray-200 px-4 py-3 sm:px-6">
                          {(value?.response_types && (value?.response_types[0] === "company_website" || value?.response_types[0] === "email")) && <button
                            className="absolute left-0 w-full h-full cursor-default bg-transparent z-10"
                          ></button>}
                          <div className="w-3/5 max-sm:w-full">
                            <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Profiling Tab</h3>
                            <p className="text-[14px] font-normal">{"Setup questions for profiling "}<span className="text-xs font-semibold">{ " (Max 1 question per tab)" }</span></p>
                          </div>
                          {!(value?.response_types && (value?.response_types[0] === "company_website" || value?.response_types[0] === "email")) &&<div className="w-1/2 max-sm:w-full flex max-sm:justify-center justify-end">
                            <Menu as="div" className="relative inline-block text-left w-9/12 max-lg:w-full max-sm:mt-2">
                              <div className="flex items-center justify-end">
                                  <Menu.Button disabled={disableHandle(value, "text")} onClick={()=>{setIsOpen(true)}} className="inline-flex w-1/2 justify-center border border-gray-200 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                  { !disableHandle(value, "text") ? <span className="flex">
                                      Add Fields
                                      <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </span> :
                                    <span>Add Fields</span>}
                                  </Menu.Button>
                                  {/* <button onClick={() => {removeGroup(value.group_id, value)}} className="flex w-full justify-center border cursor-pointer border-gray-200 gap-x-1.5 rounded-md bg-white ml-2 px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
                                    <Icon.Trash className="text-xl text-gray-600 cursor-pointer"/>
                                    Remove
                                  </button> */}
                              </div>
                              
                              {isOpen && <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className={"absolute right-0 z-10 mt-2 w-56 h-[17vh] overflow-y-auto listing origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(actualResponseType.length <= 0 ? " hidden ":"")}>
                                  <div className="py-1">
                                    {actualResponseType && actualResponseType.map((r_item, index) => {
                                      return (
                                        <>
                                          {r_item.field_type === "text" && <Menu.Item >
                                            {({ active }) => (
                                              <button
                                                className={classNames(
                                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                  'block px-4 py-2 text-sm cursor-pointer w-full text-left'
                                                )}
                                                onClick={(e) => {
                                                  if (!disableHandle(value, "text")) {
                                                    addTodo(e, r_item, value);
                                                    setIsOpen(false);
                                                  }
                                                }}
                                              >
                                                {r_item.display}
                                                <span className="inline-flex ml-2 capitalize items-center rounded-md bg-yellow-50 px-1.5 py-0.5 text-[10px] font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                                                  {r_item.object_type}
                                                </span>
                                              </button>
                                            )}
                                          </Menu.Item>}
                                        </>
                                      )
                                    })}
                                  </div>
                                </Menu.Items>
                              </Transition>}
                            </Menu>    
                          </div>}
                        </div>
                        {value.questions.length > 0 &&
                          <div className="bg-white rounded-md px-6 py-3 pb-0 mt-0">
                            {(value.questions.length > 0 || checkVisiblity("data",value.questions)) && value.questions.map((inner_item, inner_index) => (
                              <>
                                {(inner_item.deleted !== true && inner_index === 0) && <div className="relative">
                                  <div className="flex justify-between items-center dragging-position">         
                                    <div className={"rounded-md px-3 pb-1.5 mb-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200 "+(!(value?.response_types && (value?.response_types[0] === "company_website" || value?.response_types[0] === "email")) ? "w-[95%]":"w-[100%]")}>
                                      <label
                                        htmlFor="name"
                                        className="block text-xs font-medium text-gray-800 capitalize"
                                      >
                                        {inner_item?.response_type?.display}
                                      </label>
                                      <TextInput                  
                                          value={inner_item.question}
                                          onChange={(e) => {
                                            handleInputChange(e, value.widget_type, value.group_id, inner_item.self_id);
                                          }}
                                      />
                                    </div>
                                    {!(value?.response_types && (value?.response_types[0] === "company_website" || value?.response_types[0] === "email")) && <div className="w-[5%] relative inline-block text-center"><button type="button" onClick={(e) => {
                                        removeQuestion(inner_item.self_id, value.group_id, inner_item.response_type)
                                    }}><Icon.Trash className="text-xl text-gray-600 cursor-pointer" /></button></div>}
                                  </div>
                                </div>}
                              </>
                              )
                            )}
                          </div>
                        }
                        {(value.questions.length === 0 || checkVisiblity("empty",value.questions)) &&
                          <div className="bg-white rounded-md px-6 py-3 mt-0 max-h-[58vh] overflow-y-scroll listing">
                            <div className="flex justify-center items-center px-4 py-5 sm:px-6">
                              <div className="text-center">
                                <h3 className="text-[14px] mb-2 font-semibold leading-6 text-gray-900">No Fields Added</h3>
                                <p className="text-[14px] font-normal">Get Started by Adding a Field</p>
                              </div>
                            </div>
                          </div>
                        }
                      </div>}
                      {((value.widget_type === "single") && value.deleted !== true && index === leadListing?.length-1 ) && <div className="bg-white drop-shadow-md mb-3">
                        <div data-movable-handle className="flex max-sm:block justify-between items-center border-b border-gray-200 px-4 py-3 sm:px-6">
                            <div className="w-3/5 max-sm:w-full">
                                <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Profiling Tab</h3>
                              <p className="text-[14px] font-normal">{"Setup questions for profiling "}<span className="text-xs font-semibold">{ " (Max 3 question per tab)" }</span></p>
                            </div>
                            <div className="w-1/2 justify-end 2 max-sm:w-full flex max-sm:justify-center">
                              <Menu as="div" className="relative inline-block text-left w-9/12  max-lg:w-full max-sm:mt-2">
                              <div className="flex justify-end">
                                <Menu.Button disabled={disableHandle(value, "single")} onClick={()=>{setIsOpen(true)}} className="inline-flex w-1/2 justify-center border border-gray-200 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                  { !disableHandle(value, "single") ? <span className="flex">
                                    Add Fields
                                    <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                  </span> :
                                  <span>Add Fields</span>}
                                </Menu.Button>
                                {/* <button onClick={() => {removeGroup(value.group_id, value)}} className="flex w-full justify-center border cursor-pointer border-gray-200 gap-x-1.5 rounded-md bg-white ml-2 px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
                                  <Icon.Trash className="text-xl text-gray-600 cursor-pointer"/>
                                  Remove
                                </button> */}
                              </div>

                              { isOpen && <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className={"absolute right-0 z-10 mt-2 w-56 h-[17vh] overflow-y-auto listing origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(actualResponseType.length <= 0 ? " hidden ":"")}>
                                  <div className="py-1">
                                    {actualResponseType && actualResponseType.map((r_item, index) => {
                                      return (
                                        <>
                                          {(r_item.field_type === "single" || r_item.field_type === "tab") && <Menu.Item >
                                            {({ active }) => (
                                              <button
                                                className={classNames(
                                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                  'block px-4 py-2 text-sm cursor-pointer w-full text-left'
                                                )}
                                                onClick={(e) => {
                                                  if (!disableHandle(value, "single")) {
                                                    addTodo(e, r_item, value);
                                                    if (value.questions.length > 1) {
                                                      setIsOpen(false);
                                                    }
                                                  }
                                                }}
                                              >
                                                {r_item.display}
                                                <span className="inline-flex ml-2 capitalize items-center rounded-md bg-yellow-50 px-1.5 py-0.5 text-[10px] font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                                                  {r_item.object_type}
                                                </span>
                                              </button>
                                            )}
                                          </Menu.Item>}
                                        </>
                                      )
                                    })}
                                  </div>
                                </Menu.Items>
                              </Transition>}
                            </Menu>    
                          </div>
                        </div>
                        {(value.questions.length > 0 || checkVisiblity("data",value.questions)) &&
                          <>
                            {value.questions?.length > 0 && (
                              <List
                                values={value.questions}
                                onChange={(e) => { handleQuestionsChange(e, value.questions); }}
                                renderList={({ children, props: innerProps }) => (
                                  <div className="bg-white rounded-md px-6 py-3 pb-0 mt-0" {...innerProps}>
                                    {children}
                                  </div>
                                )}
                                renderItem={({ value :inner_value, props: innerProps }) => (
                                  <div className="relative" key={inner_value.self_id}>
                                    <div className="flex items-center mb-3 dragging-position">                                    
                                      <div className="rounded-md w-[95%] mb-4 px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                                        <label
                                          htmlFor="inner-name"
                                          className="block text-xs font-medium text-gray-800 capitalize"
                                        >
                                          {inner_value?.response_type?.display} Capture
                                        </label>
                                        <span data-movable-handle></span>
                                        <TextInput                  
                                          value={inner_value.question}
                                          onChange={(e) => {
                                            handleInputChange(e, value.widget_type, value.group_id, inner_value.self_id);
                                          }}
                                        />
                                        <div className="my-2 mt-3 multi-css-class">
                                          <MultiSelect option={ inner_value?.response_type?.options } selected={inner_value.options} i_index={value.group_id} inner_index={inner_value.self_id} handleMultipleInputChange={handleMultipleInputChange} />
                                        </div>
                                      </div>
                                      <div className="w-[5%] relative inline-block text-center"><button type="button" onClick={(e) => {removeQuestion(inner_value.self_id, value.group_id, inner_value.response_type)}}><Icon.Trash className="text-xl text-gray-600 cursor-pointer"/></button></div>
                                    </div>
                                  </div>
                                )}
                              />
                            )}
                          </>
                        }
                        {(value.questions.length === 0 || checkVisiblity("empty",value.questions)) &&
                          <div className="bg-white rounded-md px-6 py-3 mt-0 max-h-[58vh] overflow-y-scroll listing">
                            <div className="flex justify-center items-center px-4 py-5 sm:px-6">
                              <div className="text-center">
                                <h3 className="text-[14px] mb-2 font-semibold leading-6 text-gray-900">No Fields Added</h3>
                                <p className="text-[14px] font-normal">Get Started by Adding a Field</p>
                              </div>
                            </div>
                          </div>
                        }
                      </div>}
                      {(value.widget_type === "multi" && value.deleted !== true) && <div className="bg-white drop-shadow-md mb-3">
                        <div className="flex justify-between items-center border-b border-gray-200 px-4 py-3 sm:px-6">
                            <div className="w-3/5">
                                <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Multiple-Choice Group { index+1 }</h3>
                              <p className="text-[14px] font-normal">Setup questions for profiling</p>
                            </div>
                            <div className="w-2/5 flex justify-end">
                              <Menu as="div" className="relative inline-block text-left w-9/12">
                              <div className="flex">
                                <Menu.Button disabled={disableHandle(value, "multi")} className="inline-flex w-full justify-center border border-gray-200 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                  { !disableHandle(value, "multi") ? <span className="flex">
                                    Add Fields
                                    <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                  </span> :
                                  <span>Add Fields</span>}
                                </Menu.Button>
                                <div onClick={() => {removeGroup(value.group_id, value)}} className="flex w-full justify-center border cursor-pointer border-gray-200 gap-x-1.5 rounded-md bg-white ml-2 px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
                                  <Icon.Trash className="text-xl text-gray-600 cursor-pointer"/>
                                  Remove
                                </div>
                              </div>

                              <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className={"absolute left-0 z-10 mt-2 w-56 h-[17vh] overflow-y-auto listing origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(actualResponseType.length <= 0 ? " hidden ":"")}>
                                  <div className="py-1">
                                    {actualResponseType && actualResponseType.map((r_item, index) => {
                                      return (
                                        <>
                                          {r_item.field_type === "multi" && <Menu.Item >
                                            {({ active }) => (
                                              <span
                                                href="#"
                                                className={classNames(
                                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                  'block px-4 py-2 text-sm cursor-pointer'
                                                )}
                                                onClick={(e) => {
                                                  if (!disableHandle(value, "multi")) {
                                                    addTodo(e, r_item, value)
                                                  }
                                                }}
                                              >
                                                {r_item.display}
                                              </span>
                                            )}
                                          </Menu.Item>}
                                        </>
                                      )
                                    })}
                                  </div>
                                </Menu.Items>
                              </Transition>
                            </Menu>    
                          </div>
                        </div>
                        {(value.questions.length > 0 || checkVisiblity("data",value.questions)) &&
                          <div className="bg-white rounded-md px-6 py-3 pb-0 mt-0">
                            {value.questions?.length > 0 && value.questions.map((inner_item, inner_index) => (
                              <>
                                {inner_item.deleted !== true && <div className="relative">
                                  <div className="flex justify-between items-center mb-3 dragging-position">         
                                    <div className="rounded-md w-[95%] mb-4 px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                                      <label
                                        htmlFor="name"
                                        className="block text-xs font-medium text-gray-800 capitalize"
                                      >
                                        {inner_item?.response_type.display} Capture
                                      </label>
                                      <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={inner_item.question}
                                        onChange={(e) => {
                                          handleInputChange(e, value.widget_type, value.group_id, inner_item.self_id);
                                        }}
                                        className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 pr-[40px] sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                                        placeholder="Enter Question here"
                                      />
                                      <div className="my-2 mt-3">
                                        <MultiSelect option={ inner_item?.response_type?.options } selected={inner_item.options} i_index={value.group_id} inner_index={inner_item.self_id} handleMultipleInputChange={handleMultipleInputChange} />
                                      </div>
                                      <Icon.Trash onClick={() => {removeQuestion(inner_item.self_id, value.group_id, inner_item.response_type)}} className="absolute text-xl right-2.5 top-[35%] text-gray-600 cursor-pointer"/>
                                    </div>
                                  </div>
                                </div>}
                              </>
                              )
                            )}
                          </div>
                        }
                        {(value.questions.length === 0 || checkVisiblity("empty",value.questions)) &&
                          <div className="bg-white rounded-md px-6 py-3 mt-0 max-h-[58vh] overflow-y-scroll listing">
                            <div className="flex justify-center items-center px-4 py-5 sm:px-6">
                              <div className="text-center">
                                <h3 className="text-[14px] mb-2 font-semibold leading-6 text-gray-900">No Fields Added</h3>
                                <p className="text-[14px] font-normal">Get Started by Adding a Field</p>
                              </div>
                            </div>
                          </div>
                        }
                      </div>}
                    </div>
                );
              })  
            }
            </div>
          </>
        }
        
        {currentActivePage === "edit_c_q" &&
          <>
            <div ref={questionEl} className="xl:h-[65vh] h-[62vh] max-lg:h-[72vh] overflow-y-auto listing pr-2">
              {leadListing?.length > 0 &&
                <List
                  values={leadListing}
                  onChange={(e) => { handleGroupChange(e, leadListing); }}
                  renderList={({ children, props }) => (
                    <div {...props}>
                      {children}
                    </div>
                  )}
                  renderItem={({ value, props, index, isDragged, isSelected }) => (
                    <div {...props}>
                      {(value.widget_type === "text" && value.deleted !== true) && <div className="bg-white drop-shadow-md mb-3">
                        <div data-movable-handle className="flex max-sm:block relative justify-between items-center border-b border-gray-200 px-4 py-3 sm:px-6">
                          {(value?.response_types && (value?.response_types[0] === "company_website" || value?.response_types[0] === "email")) && <button
                            className="absolute left-0 w-full h-full cursor-default bg-transparent z-10"
                          ></button>}
                          <div className="w-3/5 max-sm:w-full">
                            <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Profiling Tab { index+1 } {index < 2 && <span className="text-[red]">*</span>}</h3>
                            <p className="text-[14px] font-normal">{"Setup questions for profiling "}<span className="text-xs font-semibold">{ " (Max 1 question per tab)" }</span></p>
                          </div>
                          {!(value?.response_types && (value?.response_types[0] === "company_website" || value?.response_types[0] === "email")) &&<div className="w-1/2 max-sm:w-full flex max-sm:justify-center justify-end">
                            <Menu as="div" className="relative inline-block text-left w-9/12 max-lg:w-full max-sm:mt-2">
                              <div className="flex items-center">
                                  <Menu.Button disabled={disableHandle(value, "text")} onClick={()=>{setIsOpen(true)}} className="inline-flex w-full justify-center border border-gray-200 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                  { !disableHandle(value, "text") ? <span className="flex">
                                      Add Fields
                                      <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </span> :
                                    <span>Add Fields</span>}
                                  </Menu.Button>
                                  <button onClick={() => {removeGroup(value.group_id, value)}} className="flex w-full justify-center border cursor-pointer border-gray-200 gap-x-1.5 rounded-md bg-white ml-2 px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
                                    <Icon.Trash className="text-xl text-gray-600 cursor-pointer"/>
                                    Remove
                                  </button>
                              </div>
                              
                              {isOpen && <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className={"absolute left-0 z-10 mt-2 w-56 h-[17vh] overflow-y-auto listing origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(actualResponseType.length <= 0 ? " hidden ":"")}>
                                  <div className="py-1">
                                    {actualResponseType && actualResponseType.map((r_item, index) => {
                                      return (
                                        <>
                                          {r_item.field_type === "text" && <Menu.Item >
                                            {({ active }) => (
                                              <button
                                                className={classNames(
                                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                  'block px-4 py-2 text-sm cursor-pointer w-full text-left'
                                                )}
                                                onClick={(e) => {
                                                  if (!disableHandle(value, "text")) {
                                                    addTodo(e, r_item, value);
                                                    setIsOpen(false);
                                                  }
                                                }}
                                              >
                                                {r_item.display}
                                                <span className="inline-flex ml-2 capitalize items-center rounded-md bg-yellow-50 px-1.5 py-0.5 text-[10px] font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                                                  {r_item.object_type}
                                                </span>
                                              </button>
                                            )}
                                          </Menu.Item>}
                                        </>
                                      )
                                    })}
                                  </div>
                                </Menu.Items>
                              </Transition>}
                            </Menu>    
                          </div>}
                        </div>
                        {value.questions.length > 0 &&
                          <div className="bg-white rounded-md px-6 py-3 pb-0 mt-0">
                            {(value.questions.length > 0 || checkVisiblity("data",value.questions)) && value.questions.map((inner_item, inner_index) => (
                              <>
                                {(inner_item.deleted !== true && inner_index === 0) && <div className="relative">
                                  <div className="flex justify-between items-center dragging-position">         
                                    <div className={"rounded-md px-3 pb-1.5 mb-3 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200 "+(!(value?.response_types && (value?.response_types[0] === "company_website" || value?.response_types[0] === "email")) ? "w-[95%]":"w-[100%]")}>
                                      <label
                                        htmlFor="name"
                                        className="block text-xs font-medium text-gray-800 capitalize"
                                      >
                                        {inner_item?.response_type?.display}
                                      </label>
                                      <TextInput                  
                                          value={inner_item.question}
                                          onChange={(e) => {
                                            handleInputChange(e, value.widget_type, value.group_id, inner_item.self_id);
                                          }}
                                      />
                                    </div>
                                    {!(value?.response_types && (value?.response_types[0] === "company_website" || value?.response_types[0] === "email")) && <div className="w-[5%] relative inline-block text-center"><button type="button" onClick={(e) => {
                                        removeQuestion(inner_item.self_id, value.group_id, inner_item.response_type)
                                    }}><Icon.Trash className="text-xl text-gray-600 cursor-pointer" /></button></div>}
                                  </div>
                                </div>}
                              </>
                              )
                            )}
                          </div>
                        }
                        {(value.questions.length === 0 || checkVisiblity("empty",value.questions)) &&
                          <div className="bg-white rounded-md px-6 py-3 mt-0 max-h-[58vh] overflow-y-scroll listing">
                            <div className="flex justify-center items-center px-4 py-5 sm:px-6">
                              <div className="text-center">
                                <h3 className="text-[14px] mb-2 font-semibold leading-6 text-gray-900">No Fields Added</h3>
                                <p className="text-[14px] font-normal">Get Started by Adding a Field</p>
                              </div>
                            </div>
                          </div>
                        }
                      </div>}
                      {((value.widget_type === "single") && value.deleted !== true) && <div className="bg-white drop-shadow-md mb-3">
                        <div data-movable-handle className="flex max-sm:block justify-between items-center border-b border-gray-200 px-4 py-3 sm:px-6">
                            <div className="w-3/5 max-sm:w-full">
                                <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Profiling Tab { index+1 }</h3>
                              <p className="text-[14px] font-normal">{"Setup questions for profiling "}<span className="text-xs font-semibold">{ " (Max 3 questions per tab)" }</span></p>
                            </div>
                            <div className="w-1/2 justify-end 2 max-sm:w-full flex max-sm:justify-center">
                              <Menu as="div" className="relative inline-block text-left w-9/12  max-lg:w-full max-sm:mt-2">
                              <div className="flex">
                                <Menu.Button disabled={disableHandle(value, "single")} onClick={()=>{setIsOpen(true)}} className="inline-flex w-full justify-center border border-gray-200 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                  { !disableHandle(value, "single") ? <span className="flex">
                                    Add Fields
                                    <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                  </span> :
                                  <span>Add Fields</span>}
                                </Menu.Button>
                                <button onClick={() => {removeGroup(value.group_id, value)}} className="flex w-full justify-center border cursor-pointer border-gray-200 gap-x-1.5 rounded-md bg-white ml-2 px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
                                  <Icon.Trash className="text-xl text-gray-600 cursor-pointer"/>
                                  Remove
                                </button>
                              </div>

                              { isOpen && <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className={"absolute left-0 z-10 mt-2 w-56 h-[17vh] overflow-y-auto listing origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(actualResponseType.length <= 0 ? " hidden ":"")}>
                                  <div className="py-1">
                                    {actualResponseType && actualResponseType.map((r_item, index) => {
                                      return (
                                        <>
                                          {(r_item.field_type === "single" || r_item.field_type === "tab") && <Menu.Item >
                                            {({ active }) => (
                                              <button
                                                className={classNames(
                                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                  'block px-4 py-2 text-sm cursor-pointer w-full text-left'
                                                )}
                                                onClick={(e) => {
                                                  if (!disableHandle(value, "single")) {
                                                    addTodo(e, r_item, value);
                                                    if (value.questions.length > 1) {
                                                      setIsOpen(false);
                                                    }
                                                  }
                                                }}
                                              >
                                                {r_item.display}
                                                <span className="inline-flex ml-2 capitalize items-center rounded-md bg-yellow-50 px-1.5 py-0.5 text-[10px] font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                                                  {r_item.object_type}
                                                </span>
                                              </button>
                                            )}
                                          </Menu.Item>}
                                        </>
                                      )
                                    })}
                                  </div>
                                </Menu.Items>
                              </Transition>}
                            </Menu>    
                          </div>
                        </div>
                        {(value.questions.length > 0 || checkVisiblity("data",value.questions)) &&
                          <>
                            {value.questions?.length > 0 && (
                              <List
                                values={value.questions}
                                onChange={(e) => { handleQuestionsChange(e, value.questions); }}
                                renderList={({ children, props: innerProps }) => (
                                  <div className="bg-white rounded-md px-6 py-3 pb-0 mt-0" {...innerProps}>
                                    {children}
                                  </div>
                                )}
                                renderItem={({ value :inner_value, props: innerProps }) => (
                                  <div className="relative" key={inner_value.self_id}>
                                    <div className="flex items-center mb-3 dragging-position">                                    
                                      <div className="rounded-md w-[95%] mb-4 px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                                        <label
                                          htmlFor="inner-name"
                                          className="block text-xs font-medium text-gray-800 capitalize"
                                        >
                                          {inner_value?.response_type?.display} Capture
                                        </label>
                                        <span data-movable-handle></span>
                                        <TextInput                  
                                          value={inner_value.question}
                                          onChange={(e) => {
                                            handleInputChange(e, value.widget_type, value.group_id, inner_value.self_id);
                                          }}
                                        />
                                        <div className="my-2 mt-3 multi-css-class">
                                          <MultiSelect option={ inner_value?.response_type?.options } selected={inner_value.options} i_index={value.group_id} inner_index={inner_value.self_id} handleMultipleInputChange={handleMultipleInputChange} />
                                        </div>
                                      </div>
                                      <div className="w-[5%] relative inline-block text-center"><button type="button" onClick={(e) => {removeQuestion(inner_value.self_id, value.group_id, inner_value.response_type)}}><Icon.Trash className="text-xl text-gray-600 cursor-pointer"/></button></div>
                                    </div>
                                  </div>
                                )}
                              />
                            )}
                          </>
                        }
                        {(value.questions.length === 0 || checkVisiblity("empty",value.questions)) &&
                          <div className="bg-white rounded-md px-6 py-3 mt-0 max-h-[58vh] overflow-y-scroll listing">
                            <div className="flex justify-center items-center px-4 py-5 sm:px-6">
                              <div className="text-center">
                                <h3 className="text-[14px] mb-2 font-semibold leading-6 text-gray-900">No Fields Added</h3>
                                <p className="text-[14px] font-normal">Get Started by Adding a Field</p>
                              </div>
                            </div>
                          </div>
                        }
                      </div>}
                      {(value.widget_type === "multi" && value.deleted !== true) && <div className="bg-white drop-shadow-md mb-3">
                        <div className="flex justify-between items-center border-b border-gray-200 px-4 py-3 sm:px-6">
                            <div className="w-3/5">
                                <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Multiple-Choice Group { index+1 }</h3>
                              <p className="text-[14px] font-normal">Setup questions for profiling</p>
                            </div>
                            <div className="w-2/5 flex justify-end">
                              <Menu as="div" className="relative inline-block text-left w-9/12">
                              <div className="flex">
                                <Menu.Button disabled={disableHandle(value, "multi")} className="inline-flex w-full justify-center border border-gray-200 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                  { !disableHandle(value, "multi") ? <span className="flex">
                                    Add Fields
                                    <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                  </span> :
                                  <span>Max 3 per Group</span>}
                                </Menu.Button>
                                <div onClick={() => {removeGroup(value.group_id, value)}} className="flex w-full justify-center border cursor-pointer border-gray-200 gap-x-1.5 rounded-md bg-white ml-2 px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
                                  <Icon.Trash className="text-xl text-gray-600 cursor-pointer"/>
                                  Remove
                                </div>
                              </div>

                              <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className={"absolute right-0 z-10 mt-2 w-56 h-[17vh] overflow-y-auto listing origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(actualResponseType.length <= 0 ? " hidden ":"")}>
                                  <div className="py-1">
                                    {actualResponseType && actualResponseType.map((r_item, index) => {
                                      return (
                                        <>
                                          {r_item.field_type === "multi" && <Menu.Item >
                                            {({ active }) => (
                                              <span
                                                href="#"
                                                className={classNames(
                                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                  'block px-4 py-2 text-sm cursor-pointer'
                                                )}
                                                onClick={(e) => {
                                                  if (!disableHandle(value, "multi")) {
                                                    addTodo(e, r_item, value)
                                                  }
                                                }}
                                              >
                                                {r_item.display}
                                              </span>
                                            )}
                                          </Menu.Item>}
                                        </>
                                      )
                                    })}
                                  </div>
                                </Menu.Items>
                              </Transition>
                            </Menu>    
                          </div>
                        </div>
                        {(value.questions.length > 0 || checkVisiblity("data",value.questions)) &&
                          <div className="bg-white rounded-md px-6 py-3 pb-0 mt-0">
                            {value.questions?.length > 0 && value.questions.map((inner_item, inner_index) => (
                              <>
                                {inner_item.deleted !== true && <div className="relative">
                                  <div className="flex justify-between items-center mb-3 dragging-position">         
                                    <div className="rounded-md w-[95%] mb-4 px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                                      <label
                                        htmlFor="name"
                                        className="block text-xs font-medium text-gray-800 capitalize"
                                      >
                                        {inner_item?.response_type.display} Capture
                                      </label>
                                      <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={inner_item.question}
                                        onChange={(e) => {
                                          handleInputChange(e, value.widget_type, value.group_id, inner_item.self_id);
                                        }}
                                        className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 pr-[40px] sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                                        placeholder="Enter Question here"
                                      />
                                      <div className="my-2 mt-3">
                                        <MultiSelect option={ inner_item?.response_type?.options } selected={inner_item.options} i_index={value.group_id} inner_index={inner_item.self_id} handleMultipleInputChange={handleMultipleInputChange} />
                                      </div>
                                      <Icon.Trash onClick={() => {removeQuestion(inner_item.self_id, value.group_id, inner_item.response_type)}} className="absolute text-xl right-2.5 top-[35%] text-gray-600 cursor-pointer"/>
                                    </div>
                                  </div>
                                </div>}
                              </>
                              )
                            )}
                          </div>
                        }
                        {(value.questions.length === 0 || checkVisiblity("empty",value.questions)) &&
                          <div className="bg-white rounded-md px-6 py-3 mt-0 max-h-[58vh] overflow-y-scroll listing">
                            <div className="flex justify-center items-center px-4 py-5 sm:px-6">
                              <div className="text-center">
                                <h3 className="text-[14px] mb-2 font-semibold leading-6 text-gray-900">No Fields Added</h3>
                                <p className="text-[14px] font-normal">Get Started by Adding a Field</p>
                              </div>
                            </div>
                          </div>
                        }
                      </div>}
                    </div>
                  )}
                />
              }
            </div>
            <span className="flex justify-between items-center text-[12px] px-1 py-1 sm:px-2 font-medium leading-6 text-[red]">( * ) Only question is editable in the group</span>
          </>
        }

        {currentActivePage === "edit_m_q" &&
          <>
            <div className="bg-white drop-shadow-md">
              <div className="flex justify-between items-center border-b border-gray-200 px-4 py-4 sm:px-4">
                <div>
                <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Meeting Question</h3>
                  <p className="text-[14px] font-normal">Please frame the question which will be prompted alongside the calendar when it is triggered.</p>
                </div>
              </div>
              <div className="bg-white rounded-md px-4 py-4 mt-0 overflow-auto listing">
                <div className="flex justify-between items-center">
                  <div className="relative rounded-md w-full px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Message"
                      value={meetingQuestion}
                      onChange={(e) => { setMeetingQuestion(e.target.value) }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        </>:<>
          {/* Trigger and Acknowledgment block */}
        {currentSettingPage !== "listing" && <span onClick={() => { setCurrentSettingPage("listing"); dispatch(fetchEditData(props.authToken, api_call_hider)); }} className="text-[#6B7280] text-sm not-italic font-medium leading-5 cursor-pointer flex items-center mb-2"><Icon.ChevronLeft className="text-[#6B7280] font-medium text-[13px] mr-1" aria-hidden="true" />Back</span>}
        {currentSettingPage === "listing" && <>
          <div className="bg-white drop-shadow-md mt-5">
            <h3 className="border-b flex justify-between items-center border-gray-200 text-[15px] px-4 py-3 sm:px-6 font-semibold leading-6 text-gray-900">Trigger 
              {((edit_engage?.time_duration === null || edit_engage?.time_duration === "") && (edit_engage?.chat_length === null || edit_engage?.chat_length === "") && (edit_engage?.acknowledgment === null || edit_engage?.acknowledgment === "")) ?
                <span onClick={() => { setCurrentSettingPage("edit_t_a") }} className="flex items-center justify-center border border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                  <Icon.Plus className="cursor-pointer text-gray-600 text-[16px]" />Add
                </span>
                :
                <span onClick={() => { setCurrentSettingPage("edit_t_a") }} className="flex items-center justify-center border border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                  <Icon.Pencil className="cursor-pointer text-gray-600 text-[16px]" />
                </span>
                }
            </h3>
            <div className="border-b border-gray-200 px-4 sm:px-6">
              <div className="flex max-sm:block py-2">
                <div className="w-[40%] max-sm:w-full flex">
                  <p className="text-sm font-semibold leading-6 text-gray-900">Profiling Questions Trigger</p>
                </div>
                <div className="w-[60%] max-sm:w-full flex max-sm:justify-start justify-end">
                    <div className="mt-1">
                      <p className="max-sm:hidden text-[14px] leading-5 text-[#000000]">
                        { (lead_trigger_data?.time_duration !== null && lead_trigger_data?.chat_length !== null) && <p className="font-normal">After {lead_trigger_data?.time_duration} seconds or {lead_trigger_data?.chat_length} prompts</p>}
                        { (lead_trigger_data?.time_duration !== null && lead_trigger_data?.chat_length === null) && <p className="font-normal">After {lead_trigger_data?.time_duration} seconds</p>}
                        { (lead_trigger_data?.time_duration === null && lead_trigger_data?.chat_length !== null) && <p className="font-normal">After {lead_trigger_data?.chat_length} prompts</p>}
                      </p>
                      <p className="hidden max-sm:inline text-[14px] leading-5 text-[#000000]">
                        { (lead_trigger_data?.time_duration !== null && lead_trigger_data?.chat_length !== null) && <p className="font-normal">After {lead_trigger_data?.time_duration} seconds or {lead_trigger_data?.chat_length} prompts</p>}
                        { (lead_trigger_data?.time_duration !== null && lead_trigger_data?.chat_length === null) && <p className="font-normal">After {lead_trigger_data?.time_duration} seconds</p>}
                        { (lead_trigger_data?.time_duration === null && lead_trigger_data?.chat_length !== null) && <p className="font-normal">After {lead_trigger_data?.chat_length} prompts</p>}
                      </p>
                    </div>
                </div>
              </div>
            </div>
            <div className="border-b border-gray-200 px-4 sm:px-6">
              <div className="flex max-sm:block py-2">
                <div className="w-[40%] max-sm:w-full flex">
                  <p className="text-sm font-semibold leading-6 text-gray-900">Calendar Trigger</p>
                </div>
                <div className="w-[60%] max-sm:w-full flex max-sm:justify-start justify-end">
                    <div className="mt-1">
                      <p className="max-sm:hidden text-[14px] font-normal leading-5 text-[#000000]">
                        {lead_meeting_data?.meeting_triggers?.join(',')}
                      </p>
                      <p className="hidden max-sm:inline text-[14px] font-normal leading-5 text-[#000000] break-all">
                        {lead_meeting_data?.meeting_triggers?.join(',')} 
                      </p>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white drop-shadow-md mt-5">
            <h3 className="border-b flex justify-between items-center border-gray-200 text-[15px] px-4 py-3 sm:px-6 font-semibold leading-6 text-gray-900">Acknowledgment Message
              {((edit_engage?.time_duration === null || edit_engage?.time_duration === "") && (edit_engage?.chat_length === null || edit_engage?.chat_length === "") && (edit_engage?.acknowledgment === null || edit_engage?.acknowledgment === "")) ?
                <span onClick={() => { setCurrentSettingPage("edit_a") }} className="flex items-center justify-center border border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                  <Icon.Plus className="cursor-pointer text-gray-600 text-[16px]" />Add
                </span>
                :
                <span onClick={() => { setCurrentSettingPage("edit_a") }} className="flex items-center justify-center border border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                  <Icon.Pencil className="cursor-pointer text-gray-600 text-[16px]" />
                </span>
                }
            </h3>
            <div className="border-b border-gray-200 px-4 sm:px-6">
              <div className="flex max-sm:block py-2">
                <div className="w-[40%] max-sm:w-full flex">
                  <p className="text-sm font-semibold leading-6 text-gray-900">Acknowledgment</p>
                </div>
                <div className="w-[60%] max-sm:w-full flex max-sm:justify-start justify-end">
                    <div className="mt-1">
                      <p className="max-sm:hidden text-[14px] font-normal leading-5 text-[#000000]">
                        {lead_trigger_data?.acknowledgment}
                      </p>
                      <p className="hidden max-sm:inline text-[14px] font-normal leading-5 text-[#000000] break-all">
                        {lead_trigger_data?.acknowledgment} 
                      </p>
                    </div>
                </div>
              </div>
            </div>
          </div>
          </> }

          {currentSettingPage === "edit_t_a" &&
          <>
            <div className="bg-white drop-shadow-md mb-2">
              <div className="flex justify-between items-center border-b border-gray-200 px-4 py-4 sm:px-4">
                <div>
                  <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Trigger Setup</h3>
                  <p className="text-[14px] font-normal">The lead capture questions will be triggered after the prospect qualifies for the following conditions.</p>
                </div>
              </div>
              <div className="bg-white rounded-md px-4 py-4 mt-0">
                  {/* <div className="flex justify-between items-center mb-3">
                    <div className="relative rounded-md w-full px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                      <label
                        htmlFor="name"
                        className="block text-xs font-medium text-gray-800"
                      >
                          Enter Duration (seconds)
                      </label>
                    <>
                      {customizeDuration !== false ? <input
                        type="text"
                        name="name"
                        id="name"
                        value={durationValue}
                        autoFocus
                        onChange={(e) => setDurationValue(e.target.value)}
                        className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 pr-[40px] sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                        placeholder="Duration"
                      />
                      :
                      <Listbox value={durationValue}>
                        {({ open }) => (
                          <>
                            <div className="relative mt-2">
                              <Listbox.Button className="relative w-full rounded-md cursor-pointer bg-white pl-0 pr-10 text-left text-gray-900 focus:outline-none sm:text-sm sm:leading-6">
                                <span className="block truncate">{durationValue !== "" ? durationValue+" Seconds" : "Select Duration"}</span>
                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                  <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                </span>
                              </Listbox.Button>

                              <Transition
                                show={open}
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-[102%] -left-3 top-[26px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                
                                    {duration_list.map((upper_list,upper_index) => {
                                      return (
                                        <Listbox.Option
                                          className={({ active }) =>
                                            classNames(
                                              active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                              'relative cursor-default select-none py-2 pl-3 pr-9'
                                            )
                                          }
                                          onClick={() => { setDurationValue(upper_list.value); }}
                                        >
                                          {({ selected, active }) => (
                                            <>
                                              <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                {upper_list.value} Seconds
                                              </span>

                                              {selected ? (
                                                <span
                                                  className={classNames(
                                                    active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                    'absolute inset-y-0 right-0 flex items-center pr-4'
                                                  )}
                                                >
                                                  <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                </span>
                                              ) : null}
                                            </>
                                          )}
                                        </Listbox.Option>
                                      )
                                    }) }
                                    <Listbox.Option
                                        className={({ active }) =>
                                          classNames(
                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                            'relative cursor-default select-none py-2 pl-3 pr-9'
                                          )
                                        }
                                      onClick={() => { setCustomizeDuration(true); setDurationValue("")}}
                                    >
                                      {({ selected, active }) => (
                                        <>
                                          <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                            {"Customize"}
                                          </span>

                                          {selected ? (
                                            <span
                                              className={classNames(
                                                active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                'absolute inset-y-0 right-0 flex items-center pr-4'
                                              )}
                                            >
                                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                            </span>
                                          ) : null}
                                        </>
                                      )}
                                    </Listbox.Option>
                                </Listbox.Options>
                              </Transition>
                            </div>
                          </>
                        )}
                      </Listbox>}
                    </>
                    </div>
                  </div> */}
                  <div className="flex justify-between items-center mb-1">
                    <div className="relative rounded-md w-full px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                      <label
                        htmlFor="name"
                        className="block text-xs font-medium text-gray-800"
                      >
                        Number of Chats
                      </label>
                      <>
                        {customizePrompt !== false ? <input
                          type="text"
                          name="name"
                          id="name"
                          value={promptValue}
                          onChange={(e) => setPromptValue(e.target.value)}
                          autoFocus
                          className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 pr-[40px] sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                          placeholder="Select"
                        />
                        :
                        <Listbox value={promptValue}>
                          {({ open }) => (
                            <>
                              <div className="relative mt-2">
                                <Listbox.Button onClick={(e)=>{setDropControl(e.target)}} className="relative w-full rounded-md cursor-pointer bg-white pl-0 pr-10 text-left text-gray-900 focus:outline-none sm:text-sm sm:leading-6">
                                  <span className="block truncate">{promptValue !== "" ? "After "+promptValue+" Prompts" : "Select Number of Chats"}</span>
                                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                    <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                  </span>
                                </Listbox.Button>

                                <Transition
                                  show={open}
                                  as={Fragment}
                                  leave="transition ease-in duration-100"
                                  leaveFrom="opacity-100"
                                  leaveTo="opacity-0"
                                >
                                  <Listbox.Options className="relative rounded-t-none z-10 mt-1 h-[110px] listing w-[100%] left-0 top-[5px] overflow-auto rounded-md bg-white py-1 text-base border-t-[#00000020] border-t border-solid focus:outline-none sm:text-sm">
                                  
                                      {prompt_select_list.map((upper_list,upper_index) => {
                                        return (
                                          <Listbox.Option
                                            className={({ active }) =>
                                              classNames(
                                                active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                'relative cursor-default select-none py-2 pl-3 pr-9'
                                              )
                                            }
                                            onClick={() => { setPromptValue(upper_list.value)}}
                                          >
                                            {({ selected, active }) => (
                                              <>
                                                <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                  {upper_list.value} Prompts
                                                </span>

                                                {selected ? (
                                                  <span
                                                    className={classNames(
                                                      active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                      'absolute inset-y-0 right-0 flex items-center pr-4'
                                                    )}
                                                  >
                                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                  </span>
                                                ) : null}
                                              </>
                                            )}
                                          </Listbox.Option>
                                        )
                                      }) }
                                      <Listbox.Option
                                          className={({ active }) =>
                                            classNames(
                                              active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                              'relative cursor-default select-none py-2 pl-3 pr-9'
                                            )
                                          }
                                        onClick={() => { setCustomizePrompt(true); setPromptValue(""); }}
                                      >
                                        {({ selected, active }) => (
                                          <>
                                            <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                              {"Customize"}
                                            </span>

                                            {selected ? (
                                              <span
                                                className={classNames(
                                                  active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                  'absolute inset-y-0 right-0 flex items-center pr-4'
                                                )}
                                              >
                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                              </span>
                                            ) : null}
                                          </>
                                        )}
                                      </Listbox.Option>
                                  </Listbox.Options>
                                </Transition>
                              </div>
                            </>
                          )}
                        </Listbox>}
                      </>
                    </div>
                  </div>
                {/* <div className="flex justify-between items-center">
                  <div className="relative rounded-md w-full px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                    <label
                      htmlFor="name"
                      className="block text-xs font-medium text-gray-800"
                    >
                      No. of Questions to ask per Session
                    </label>
                    <>
                      {customizePrompt !== false ? <input
                        type="text"
                        name="name"
                        id="name"
                        value={promptValue}
                        onChange={(e) => setPromptValue(e.target.value)}
                        autoFocus
                        className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 pr-[40px] sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                        placeholder="Select"
                      />
                      :
                      <Listbox value={promptValue}>
                        {({ open }) => (
                          <>
                            <div className="relative mt-2">
                              <Listbox.Button onClick={(e)=>{setDropControl(e.target)}} className="relative w-full rounded-md cursor-pointer bg-white pl-0 pr-10 text-left text-gray-900 focus:outline-none sm:text-sm sm:leading-6">
                                <span className="block truncate">{promptValue !== "" ? "After "+promptValue+" Number" : "Select Number of Question"}</span>
                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                  <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                </span>
                              </Listbox.Button>

                              <Transition
                                show={open}
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-[102%] -left-3 top-[26px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                
                                    {prompt_select_list.map((upper_list,upper_index) => {
                                      return (
                                        <Listbox.Option
                                          className={({ active }) =>
                                            classNames(
                                              active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                              'relative cursor-default select-none py-2 pl-3 pr-9'
                                            )
                                          }
                                          onClick={() => { setPromptValue(upper_list.value)}}
                                        >
                                          {({ selected, active }) => (
                                            <>
                                              <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                {upper_list.value} Number
                                              </span>

                                              {selected ? (
                                                <span
                                                  className={classNames(
                                                    active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                    'absolute inset-y-0 right-0 flex items-center pr-4'
                                                  )}
                                                >
                                                  <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                </span>
                                              ) : null}
                                            </>
                                          )}
                                        </Listbox.Option>
                                      )
                                    }) }
                                    <Listbox.Option
                                        className={({ active }) =>
                                          classNames(
                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                            'relative cursor-default select-none py-2 pl-3 pr-9'
                                          )
                                        }
                                      onClick={() => { setCustomizePrompt(true); setPromptValue(""); }}
                                    >
                                      {({ selected, active }) => (
                                        <>
                                          <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                            {"Customize"}
                                          </span>

                                          {selected ? (
                                            <span
                                              className={classNames(
                                                active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                'absolute inset-y-0 right-0 flex items-center pr-4'
                                              )}
                                            >
                                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                            </span>
                                          ) : null}
                                        </>
                                      )}
                                    </Listbox.Option>
                                </Listbox.Options>
                              </Transition>
                            </div>
                          </>
                        )}
                      </Listbox>}
                    </>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="bg-white drop-shadow-md">
              <div className="flex justify-between items-center border-b border-gray-200 px-4 py-4 sm:px-4">
                <div>
                  <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Calendar Trigger</h3>
                  <p className="text-[14px] font-normal">Please enter the keywords with which you would like Zoi to trigger a calendar for a meeting booking.</p>
                </div>
              </div>
              <div className="bg-white rounded-md px-4 py-4 mt-0 overflow-auto listing">
                <div className="flex justify-between items-center">
                  <div className="relative flex rounded-md w-full px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                    {/* <div className="my-auto flex ">
                       {calendarTrigger && calendarTrigger?.map((item, index) => (
                      <div key={index} className="mr-2 my-auto mb-1 flex rounded-md bg-gray-300 p-1 text-xs">{item}<span onClick={()=>handleClose(index)} className="my-auto cursor-pointer"><IoClose/></span></div>
                       ))}
                       </div> */}
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Comma Separated Keywords"
                      value={inputValue}
                      onChange={handleCalendarTrigger}
                      // onKeyDown={handleKeyDown}
                    />
                  </div>
                </div>
              </div>
            </div>
            
          </>
        }
          {currentSettingPage === "edit_a" &&
          <>
            <div className="bg-white drop-shadow-md">
              <div className="flex justify-between items-center border-b border-gray-200 px-4 py-4 sm:px-4">
                <div>
                  <h3 className="text-[12px] font-semibold leading-6 text-gray-900">Acknowledgment Message</h3>
                  <p className="text-[14px] font-normal">This acknowledgement message will be sent once a user responds to a lead capture question.</p>
                </div>
              </div>
              <div className="bg-white rounded-md px-4 py-4 mt-0 overflow-auto listing">
                <div className="flex justify-between items-center">
                  <div className="relative rounded-md w-full px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-200">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Message"
                      value={acknowledgementValue}
                      onChange={(e) => { setAcknowledgementValue(e.target.value) }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        }
          

          </>}



        
        <ChatbotViewer authToken={props.authToken} open={open} chatOpenHandle={chatOpenHandle} autoQuestion="" />
      </div>
    </>
  );
};

export default ChatEngageProfile;
